module.exports = __webpack_public_path__ + "static/img/21.2f9169a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/21.jpg
// module id = xrG2
// module chunks = 0